import { companyagreementApi } from 'app/src/services/welfareportal'
import { Partnership, useFavouriteToggle } from 'app/src/services/welfareportal/companyagreement-api'
import { Image, Tag } from 'app/src/shared/components'
import { queryClient, replaceUrlInString } from 'app/src/shared/helpers'
import { useWebAppContext } from 'app/src/shared/hooks'
import posteXTeLogo from 'app/static/images/postexte_logo.svg'
import { Parser } from 'html-to-react'
import { useState, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export type ProductImageCarouselPropsType = {
  tag?: string
  title: string
  description: string
  productId: string
  isFavourite?: boolean
  isDiscount?: boolean
  partnership?: Partnership
}

export function ProductHeader(props: ProductImageCarouselPropsType): ReactElement {
  const { t } = useTranslation('productDetail')
  const [isFavourite, setIsFavourite] = useState(props.isFavourite)

  const context = useWebAppContext()

  const favouriteToggle = useFavouriteToggle()

  const handleFavourite = () => {
    const prevIsFavourite = isFavourite
    setIsFavourite(!prevIsFavourite)

    favouriteToggle.mutate(
      {
        body: {
          productId: props.productId,
          catalog: props.isDiscount ? 'discount' : 'welfare',
        },
      },
      {
        onSuccess: () => {
          companyagreementApi.invalidateCacheByOperationId(queryClient, 'companyagreement-api.productList')
          companyagreementApi.invalidateCacheByOperationId(queryClient, 'companyagreement-api.productGet')
        },
        onError: () => {
          setIsFavourite(prevIsFavourite)
          context.showToastMessage({
            severity: 'error',
            content: prevIsFavourite ? t('ProductDetail.Errors.removeFromFavourite') : t('ProductDetail.Errors.addToFavourite'),
          })
        },
      },
    )
  }

  return (
    <div className='my-[4px] lg:my-[40px]'>
      {props.tag && <Tag tag={props.tag} />}
      <div className='text-[32px] font-semibold leading-normal'>{props.title}</div>
      {!props.isDiscount ? (
        <div
          className={`my-4 flex cursor-pointer items-center text-[var(--primary-color)]`}
          onClick={() => {
            if (!favouriteToggle.isPending) handleFavourite()
          }}
        >
          <i className={`pi ${isFavourite ? 'pi-star-fill' : 'pi-star'} text-[20px] text-xl`}></i>
          <span className='ml-2 text-[16px] font-bold'>
            {isFavourite ? t('ProductDetail.removeFromFavourite') : t('ProductDetail.addToFavourite')}
          </span>
        </div>
      ) : (
        <></>
      )}

      {props.partnership ? (
        <div className='depth-8 flex flex-col gap-4 rounded-[8px] border-[2px] border-[#FFFFFF] bg-gradient-to-r from-[#EEDC00] to-[#F2D450] p-4'>
          <Image className='left-0 top-0' src={posteXTeLogo} alt={t('ProductDetail.productPartnership.altPosteXTe')} />
          <p>{props.partnership?.description}</p>
          <a
            className='flex items-center gap-2 font-bold text-[var(--primary-color)]'
            href={props.partnership?.link}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('ProductDetail.productPartnership.goToPosteXTe')}
            <span aria-hidden='true' className='pi pi-chevron-right'></span>
          </a>
        </div>
      ) : (
        ''
      )}
      <div className='mt-[20px] text-left text-[16px] leading-[24px]'>
        {Parser().parse(replaceUrlInString(props.description))}
      </div>
    </div>
  )
}
